import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { Client } from './clients.model';

// Leverage TypeScript type guards to check to see if we have a Character type selected
const instanceOfClient = (client: any): client is Client =>
  !!client // truthy
  && typeof client !== 'string' // Not just string input in the autocomplete
  && 'name' in client // Has some qualifying property of Character type
;

export const clientSelectionRequiredValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null =>
  (control?.value && !instanceOfClient(control?.value)) ? { matchRequired: true } : null;



